import { render, staticRenderFns } from "./ModalWebhookTester.vue?vue&type=template&id=22e5de13&scoped=true&"
import script from "./ModalWebhookTester.vue?vue&type=script&lang=js&"
export * from "./ModalWebhookTester.vue?vue&type=script&lang=js&"
import style0 from "./ModalWebhookTester.vue?vue&type=style&index=0&id=22e5de13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e5de13",
  null
  
)

export default component.exports